import { CoeficienteComision } from '../app.modules/individual/domain.models/coeficiente-comision';
import { getFieldsFromInstance } from '../core.utilidades/graphql-utils';

export class Configuracion {

    id?: number;
    minutosCarritoAbandonado: number;
    minutosCarritoAbandonadoInmediato: number;
    coeficienteComision: CoeficienteComision;
    
    constructor() {
        this.minutosCarritoAbandonado = 0;
        this.minutosCarritoAbandonadoInmediato = 0;
        this.coeficienteComision = new CoeficienteComision();
    }

    public static getFields = () => {
        return getFieldsFromInstance(new Configuracion());
    };
}